import {
  apiGetPriceCoefficients,
  apiUpdatePriceCoefficientsBulk
} from '../../../api/Argentia/endpoints/priceCoefficients'
import {
  PriceCoefficientAPI,
  UpdatePriceCoefficientsRequest,
  UpdatePriceCoefficientsServiceRequest
} from '../../../api/Argentia/endpoints/priceCoefficients/model/PriceCoefficient'
import { CreatePriceComponentRequest } from '../../../api/Argentia/endpoints/priceComponents'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../../model/serviceResponse'

export const getPriceCoefficients = async (
  priceID: number
): Promise<ServiceResponse<PriceCoefficientAPI[] | undefined>> => {
  return await apiGetPriceCoefficients(priceID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const updatePriceCoefficients = async (
  request: UpdatePriceCoefficientsServiceRequest
): Promise<ServiceResponse<PriceCoefficientAPI[] | undefined>> => {
  return await apiUpdatePriceCoefficientsBulk({ ...request, deleteMissingCoefficients: true })
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
